import React, { createContext, useContext, useState } from 'react';

const MarketsContext = createContext<any>(undefined);

export function MarketsProvider({ children }: any) {
	const [isActiveSectionEmpty, setIsActiveSectionEmpty] = useState(false);

	return (
		<MarketsContext.Provider
			value={{
				isActiveSectionEmpty,
				setIsActiveSectionEmpty,
			}}
		>
			{children}
		</MarketsContext.Provider>
	);
}

export const useMarkets = () => {
	const ctx = useContext(MarketsContext);
	if (!ctx) throw new Error('useMarkets must be inside MarketsProvider');
	return ctx;
};
